import Icon from 'components/Misc/Icon';
import Show from 'components/Show';
import React, { forwardRef } from 'react';
import { useSelected, useFocused, useReadOnly } from 'slate-react';

const Link = forwardRef(({ href, children, ...attributes }, ref) => {
	const isSelected = useSelected();
	const isFocused = useFocused();
	const isReadonly = useReadOnly();
	
	return (
		<>
			<Show if={!isReadonly && isSelected && isFocused}>
				<a
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					contentEditable={false}
				>
					<Icon icon="link" />
				</a>
			</Show>

			<a
				ref={ref}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className="underline hover:no-underline hover:text-amber-500 cursor-pointer transition-colors"
				{...attributes}
			>
				{children}
			</a>
		</>
	);
});

export default Link;
